module.exports = __webpack_public_path__ + "02ff6b3b46f94c3cf38fc6bbd7c54aee.svg";